<template>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="用户名">
        <el-input v-model="searchForm.username" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="searchForm.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="省份">
        <el-select v-model="searchForm.provinceCode" placeholder="请选择省份" clearable style="width: 150px;">
          <el-option
            v-for="item in provinceList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" @click="search()">搜索</el-button>
          <el-button type="primary" @click="showAdd()">新建</el-button>
      </el-form-item>
    </el-form>
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="用户名" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.username }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="真实姓名" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.realName }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="角色" width="180">
        <template #default="scope">
          <div>
            <span>{{scope.row.type_name}}</span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="手机号" width="180">
        <template #default="scope">
          <div>
            <span>{{ scope.row.phoneNumber }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="省份" width="120">
        <template #default="scope">
          <div>
            <span>{{ scope.row.province || '-' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180">
        <template #default="scope">
          <div>
            <span>{{ scope.row.createTime }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button size="small" type="primary" @click="handleChangePassword(scope.$index, scope.row)">
            修改密码
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 对话框--修改密码 -->
    <el-dialog v-model="dialogPasswordVisible" title="修改密码" width="500" :close-on-click-modal="false" @close="handlePasswordDialogClose">
        <el-form ref="passwordFormRef" label-position="right" label-width="auto" :model="passwordInfo" :rules="passwordRules">
          <el-form-item label="新密码" prop="newPassword" style="margin-bottom: 35px;">
            <el-input v-model="passwordInfo.newPassword" type="password" placeholder="请输入新密码" autocomplete="off" show-password />
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input v-model="passwordInfo.confirmPassword" type="password" placeholder="请确认新密码" autocomplete="off" show-password />
          </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogPasswordVisible = false">取消</el-button>
            <el-button type="primary" @click="savePassword()">确定</el-button>
        </div>
        </template>
    </el-dialog>

    <!-- 对话框--新建 -->
    <el-dialog v-model="dialogFormVisible" :title="isUpdate?'编辑用户':'新建用户'" width="800" :close-on-click-modal="false" @close="handleDialogClose">
        <el-form ref="addFormRef" label-position="right" label-width="auto" :model="addInfo" :rules="addRules">
        <el-form-item label="用户名称" prop="username">
          <el-input v-if="!isUpdate" v-model="addInfo.username" autocomplete="off" />
          <el-input v-if="isUpdate" v-model="addInfo.username" autocomplete="off" disabled />
        </el-form-item>
        <el-form-item label="密码" prop="password">
            <el-input v-if="!isUpdate" v-model="addInfo.password" autocomplete="off" show-password />
            <el-input v-if="isUpdate" v-model="addInfo.password" autocomplete="off" disabled show-password />
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName">
            <el-input v-model="addInfo.realName" autocomplete="off" />
        </el-form-item>
        <el-form-item label="组织架构" prop="orgId">
          <el-tree-select
            v-model="addInfo.orgId"
            :data="treeData"
            check-strictly
            :render-after-expand="false"
            show-checkbox
          />
        </el-form-item>
        <el-form-item label="角色" prop="roles">
            <el-select v-model="addInfo.roles" multiple clearable placeholder="请选择" collapse-tags collapse-tags-tooltip>
              <el-option
                  v-for="item in rolesList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
            <el-input v-if="!isUpdate" v-model="addInfo.phoneNumber" autocomplete="off" />
            <el-input v-if="isUpdate" v-model="addInfo.phoneNumber" autocomplete="off" disabled />
        </el-form-item>
        <el-form-item label="省份" prop="provinceCode">
            <el-select v-model="addInfo.provinceCode" placeholder="请选择省份" clearable style="width: 100%;" @change="handleProvinceChange">
              <el-option
                v-for="item in provinceList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="场站权限：">
              <el-select
                  filterable
                  v-model="selectList"
                  placeholder="请选择场站"
                  collapse-tags
                  multiple
                  clearable
                  @change="e => changeSelect(e)"
              >
                  <div class="checkboxWrapper">
                  <el-checkbox v-model="checked" @change="checkChange">
                      全选
                  </el-checkbox>
                  </div>
                  <el-option
                  v-for="item in stationOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="saveInfo()">确定</el-button>
        </div>
        </template>
    </el-dialog>

    <!-- 对话框--删除 -->
    <el-dialog
      v-model="centerDialogVisible"
      title="提示"
      width="500"
      align-center
    >
      <span>确定删除该用户？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deleteUser()">确定</el-button>
        </div>
      </template>
    </el-dialog>

  </template>
  
  <script>
  import { ref } from 'vue'
  import { required, isMobile, minLength, isStrongPassword } from '@/utils/validators';
  const treeRef = ref(null)

  const provinceList = [
    { value: '110000', label: '北京市' },
    { value: '120000', label: '天津市' },
    { value: '130000', label: '河北省' },
    { value: '140000', label: '山西省' },
    { value: '150000', label: '内蒙古自治区' },
    { value: '210000', label: '辽宁省' },
    { value: '220000', label: '吉林省' },
    { value: '230000', label: '黑龙江省' },
    { value: '310000', label: '上海市' },
    { value: '320000', label: '江苏省' },
    { value: '330000', label: '浙江省' },
    { value: '340000', label: '安徽省' },
    { value: '350000', label: '福建省' },
    { value: '360000', label: '江西省' },
    { value: '370000', label: '山东省' },
    { value: '410000', label: '河南省' },
    { value: '420000', label: '湖北省' },
    { value: '430000', label: '湖南省' },
    { value: '440000', label: '广东省' },
    { value: '450000', label: '广西壮族自治区' },
    { value: '460000', label: '海南省' },
    { value: '500000', label: '重庆市' },
    { value: '510000', label: '四川省' },
    { value: '520000', label: '贵州省' },
    { value: '530000', label: '云南省' },
    { value: '540000', label: '西藏自治区' },
    { value: '610000', label: '陕西省' },
    { value: '620000', label: '甘肃省' },
    { value: '630000', label: '青海省' },
    { value: '640000', label: '宁夏回族自治区' },
    { value: '650000', label: '新疆维吾尔自治区' },
  ];

  export default {
  name:'UserList',
  data() {
    return {
      searchForm:{
        username:'',
        phone:'',
        provinceCode:'',
      },
      dialogPasswordVisible:false,
      passwordInfo:{
        userId:'',
        newPassword:'',
        confirmPassword:'',
      },
      selectList: [],
      checked: false,
      stationOptions: [],
      provinceList: provinceList,
      rolesList: [],
      treeData: [],
      defaultCheckedKeys: [], // 设置默认勾选的节点id数组
      checkedKeys: [], // 存储当前勾选的节点id
      defaultProps: {
          children: 'children',
          label: 'label'
      },
      isUpdate:false,
      dialogFormVisible:false,
      centerDialogVisible:false,
      currt_id:'', //当前操作id
      tableData:[],
      addInfo:{
        username: '',
        password:'',
        orgId:'',
        realName: '',
        phoneNumber: '',
        roles: [],
        province: '',
        provinceCode: '',
      },
      total: 0, //总条数
      currentPage: 1, //当前页
      pageSize: 10, //每页显示条数
      passwordFormRef: null,
      addFormRef: null,
    }
  },
  components: {
    
  },
  computed: {
    filteredMessage() {
      // 这里可以实现类似过滤器的转换逻辑
    },
    passwordRules() {
      const validateConfirmPassword = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请确认新密码'));
        } else if (value !== this.passwordInfo.newPassword) {
          callback(new Error('两次输入密码不一致'));
        } else {
          callback();
        }
      };
      return {
        newPassword: [required('请输入新密码'), isStrongPassword()],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: 'blur' }],
      };
    },
    addRules() {
      return {
        username: [required('请输入用户名称')],
        password: this.isUpdate ? [] : [required('请输入密码'), isStrongPassword()],
        realName: [required('请输入真实姓名')],
        orgId: [required('请选择组织架构')],
        roles: [required('请选择角色')],
        phoneNumber: this.isUpdate ? [] : [required('请输入手机号'), isMobile()],
      };
    }
  },
  beforeCreate(){
    
  },
  created(){
    
  },
  mounted(){
    this.getList();
    this.getRolesList();
    this.getOrgList();
    this.getStationList();
  },
  methods:{
    //搜索
    search(){
      this.currentPage = 1;
      this.getList();
    },
    getStationList(){
      //获取场站列表
      let that = this;
      that.$axios.post(that.$store.state.platformApi+"station/all",{}).then(result => {
        // console.log(result);
        if(result.code==200){
          this.stationOptions = result.data;
        }
      })
    },
    handleChangePassword(index,row){
      this.passwordInfo = Object.fromEntries(
        Object.keys(this.passwordInfo).map(key => [key, ''])
      );
      this.passwordInfo.userId = row.id;
      this.dialogPasswordVisible = true;
      this.$nextTick(() => {
        if (this.$refs.passwordFormRef) {
          this.$refs.passwordFormRef.clearValidate();
        }
      });
    },
    //修改密码
    savePassword(){
      this.$refs.passwordFormRef.validate((valid) => {
        if (!valid) return;
        this.$axios.post(this.$store.state.platformApi+"user/password",JSON.stringify(this.passwordInfo)).then(result => {
          if(result.code==200){
            this.dialogPasswordVisible = false;
            this.$message({
              message: '保存成功',
              type: 'success',
            })
          }
        })
      });
    },
    changeSelect(val) {
        if (val.length === this.stationOptions.length) {
            this.checked = true;
        }else {
            this.checked = false; 
        }
    },
    checkChange(val) {
        if (val) {
            this.selectList = this.stationOptions.map(item => item.id); 
        }else {
            this.selectList = []; 
        }
    },
    handleSizeChange (val) { //每页显示条数
        this.pageSize = val;
        this.currentPage = 1;
        this.getList();
    },
    handleCurrentChange(val) { //当前页
        this.currentPage = val;
        this.getList(); //获取列表
    },
    saveInfo(){
      //保存
      let that = this;
      let param = {};
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return;
        if(that.isUpdate){
          //编辑
          var url = that.$store.state.platformApi+"user/edit";
          param.id = that.addInfo.id;
          param.realName = that.addInfo.realName;
          param.orgId = that.addInfo.orgId;
          param.province = that.addInfo.province;
          param.provinceCode = that.addInfo.provinceCode;
        }else{
          //新增
          var url = that.$store.state.platformApi+"user/add";
          param = that.addInfo;
        }
        param.roleIds = that.addInfo.roles;
        param.stationPermissions = that.selectList;

        that.$axios.post(url,JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.dialogFormVisible = false;
            that.getList();
            this.$message({
              message: '保存成功',
              type: 'success',
            })
          }
        })
      });
    },
    getOrgList(){
      //获取组织架构树
      let that = this;
      that.$axios.post(that.$store.state.platformApi+"org/tree",{}).then(result => {
        if(result.code==200){
          if(result.data.length>0){
            //返回新的组织架构树数组
            that.treeData = result.data.map(item => ({
              value: item.id,
              label: item.name,
              children: item.children ? item.children.map(item2 => ({
                value: item2.id,
                label: item2.name,
                children: item2.children ? item2.children.map(item3 => ({
                  value: item3.id,
                  label: item3.name,
                  children: item3.children ? item3.children.map(item4 => ({
                    value: item4.id,
                    label: item4.name,
                  })) : []
                })) : []
              })) : []
            }));
            // console.log('组织架构树:',that.treeData);
          }
        }
      })
    },
    getRolesList(){
      //获取角色列表
      let that = this;
      let param = {};
      param.page = 1;
      param.pageSize = 50;
      that.$axios.post(that.$store.state.platformApi+"roles/page",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.rolesList = [];
          result.data.records.forEach(item => {
            let item_obj = {};
            item_obj.label = item.name;
            item_obj.value = item.id;
            that.rolesList.push(item_obj);
          });
        }
      })
    },
    getList(){
      //获取用户列表
      let that = this;
      let param = {};
      param.page = this.currentPage;
      param.pageSize = this.pageSize;
      param.username = this.searchForm.username;
      param.phone = this.searchForm.phone;
      if (this.searchForm.provinceCode) {
        param.provinceCode = this.searchForm.provinceCode;
      }
      that.$axios.post(that.$store.state.platformApi+"user/page",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.tableData = result.data.records;
          that.total = result.data.total;
        }
      })
    },
    showAdd(){
      //打开新建
      this.isUpdate = false;
      this.checked = false;
      this.selectList = [];
      this.addInfo = {
        username: '',
        password: '',
        orgId: '',
        realName: '',
        phoneNumber: '',
        roles: [],
        province: '',
        provinceCode: '',
      };
      this.$nextTick(() => {
        if (this.$refs.addFormRef) {
          this.$refs.addFormRef.clearValidate();
        }
        this.dialogFormVisible = true;
      });
    },
    handleEdit(index,row){
      //打开编辑
      let that = this;
      that.isUpdate = true;
      that.dialogFormVisible = true;
      that.$axios.post(that.$store.state.platformApi+"user/view/"+row.id).then(result => {
        if(result.code==200){
          that.addInfo = result.data;
          that.addInfo.roles = result.data.roleIds;
          that.selectList = result.data.stationPermissions ? result.data.stationPermissions: [];
          that.$nextTick(() => {
            if (that.$refs.addFormRef) {
              that.$refs.addFormRef.clearValidate();
            }
          });
        }
      })
    },
    deleteUser(){
      //删除用户
      let that = this;
      that.$axios.post(that.$store.state.platformApi+"user/delete/"+that.currt_id).then(result => {
        // console.log(result);
        if(result.code==200){
          that.centerDialogVisible = false;
          that.getList();
          this.$message({
            message: '已删除用户',
            type: 'success',
          })
        }
      })
    },
    handleDelete(index,row){
        //删除弹窗
      this.centerDialogVisible = true;
      this.currt_id = row.id;
    },
    handleDialogClose(){
      // 关闭新建/编辑弹窗时清除校验并重置数据
      if (this.$refs.addFormRef) {
        this.$refs.addFormRef.clearValidate();
      }
      // 重置所有状态为初始值
      this.isUpdate = false;
      this.checked = false;
      this.selectList = [];
      this.addInfo = {
        username: '',
        password: '',
        orgId: '',
        realName: '',
        phoneNumber: '',
        roles: [],
        province: '',
        provinceCode: '',
      };
    },
    handlePasswordDialogClose(){
      // 关闭修改密码弹窗时清除校验
      if (this.$refs.passwordFormRef) {
        this.$refs.passwordFormRef.clearValidate();
      }
    },
    handleProvinceChange(value) {
      // 选择省份时，同时保存省份名称和编码
      const selectedProvince = provinceList.find(item => item.value === value);
      if (selectedProvince) {
        this.addInfo.province = selectedProvince.label;
        this.addInfo.provinceCode = selectedProvince.value;
      } else {
        this.addInfo.province = '';
        this.addInfo.provinceCode = '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search_nav{
    width: 100%;
    height: 60px;
}
.checkboxWrapper {
  padding: 3px 20px;
  border-bottom: 1px solid #ccc;
}
</style>